const getParcelTrackingStatusStyles = {
  display: 'flex',
  alignItems: 'center'
};
const getParcelTrackingStatusIconStyles = theme => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: theme.spacing(6)
});

export { getParcelTrackingStatusIconStyles, getParcelTrackingStatusStyles };
//# sourceMappingURL=ParcelTrackingStatusStyles.js.map
